export const RESOLUTION={
    HIGH:720,
    MEDIUM:360,
    LOW:180,
    DISABLED:0
}

export const QUALITY_RULES={
    MAX_SELECTED:6,
    HIGH_RES_VIDEO_HEIGHT: 330,
    STRIP_RESOLUTION:RESOLUTION.MEDIUM,
    MAIN_SCREEN_RESOLUTION:RESOLUTION.HIGH,
    SPACES_VIEW_RESOLUTION:RESOLUTION.LOW
}

export const QUALITY_EVENTS={
    VISIBLE_ENDPOINTS_CHANGED:'video.quality.visible.changed',
    APP_STATE_CHANGED:'app.state.changed'
}
